module.exports = "/wwwroot/img/search_page.png?ver=462ba98d";